var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9289 2C18.9289 2 19.5633 5.79937 17.4123 8.96654C16.322 10.5749 14.166 11.7742 11.564 12.7349C8.85297 11.7339 6.71683 10.547 5.63142 8.87357C3.6192 5.76218 4.20403 2.0124 4.20403 2.0124L18.9289 2Z",
    stroke: "#1C84CF",
    strokeWidth: 2.64964,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99653 15.3878H15.1681C15.1681 15.3878 14.8807 14.5356 13.4087 14.3775C13.379 14.3744 13.3492 14.3713 13.3195 14.3713C13.1411 14.3682 11.1289 14.3713 10.1376 14.3744C9.55773 14.3744 9.00264 14.5201 8.59128 14.7742C8.35338 14.9261 8.13034 15.1275 7.99653 15.3878ZM6.1875 16.4787H16.8433V15.2329C16.8433 15.2112 16.8384 15.1895 16.8334 15.1709C16.7591 14.9788 16.3329 14.0676 14.618 13.64C14.3157 13.5625 13.9935 13.5222 13.6664 13.5222C13.2055 13.5005 12.244 13.5005 12.244 13.5005V12.2083H10.8364V13.5005H9.51312C9.1761 13.5005 8.84405 13.5408 8.53181 13.6245C7.81811 13.8135 6.66827 14.2505 6.23212 15.1833C6.21725 15.2112 6.21227 15.2422 6.21227 15.2701C6.20732 15.4746 6.1875 16.4787 6.1875 16.4787Z",
    fill: "#1C84CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37819 3.20557H0.0910605C0.0910605 3.20557 -1.08356 7.27765 7.24286 10.1938L5.54289 7.96562C5.54289 7.96562 2.54439 7.19397 1.74645 4.13526H4.44262L4.37819 3.20557Z",
    fill: "#1C84CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7514 3.20557H23.0385C23.0385 3.20557 24.2131 7.27765 15.8867 10.1938L17.5867 7.96562C17.5867 7.96562 20.5852 7.19397 21.3832 4.13526H18.687L18.7514 3.20557Z",
    fill: "#1C84CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4252 4.0918L12.3619 5.39028C12.3817 5.41817 12.4115 5.44296 12.4511 5.46155C12.4908 5.48015 12.5354 5.49254 12.5849 5.49564L14.8053 5.65989L13.1599 6.62987C13.1252 6.65157 13.0954 6.67636 13.0806 6.70735C13.0657 6.73524 13.0607 6.76933 13.0706 6.79722L13.5118 8.19796L11.559 7.49759C11.5144 7.4821 11.4698 7.4759 11.4202 7.4759C11.3707 7.4759 11.3261 7.48519 11.2815 7.49759L9.32872 8.19796L9.76983 6.79722C9.77974 6.76623 9.77477 6.73524 9.75991 6.70735C9.74504 6.67946 9.72024 6.65157 9.68059 6.62987L8.03516 5.65989L10.2605 5.49254C10.31 5.48944 10.3546 5.47705 10.3943 5.45845C10.4339 5.43986 10.4637 5.41507 10.4835 5.38718L11.4252 4.0918Z",
    fill: "#1C84CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTrophy);
export default __webpack_public_path__ + "static/media/menuTrophy.a9c0b715e0bc4617f34d243849b7f59c.svg";
export { ForwardRef as ReactComponent };